import { combineReducers } from 'redux'
import P from 'helpers/predicates'
import {
  UPDATE_MY_PROJECTS_LIST,
  UPDATE_SELECTED_PROJECTS,
  UPDATE_CHANGED_PROJECTS,
  APPLY_CHANGES,
  CANCEL_CHANGES,
  UPDATE_CURRENT_INDEX,
  UPDATE_INPUT_HEADER_LIST,
  UPDATE_MENU_ACTIVE,
  UPDATE_LIST_ORDER,
  UPDATE_SORT_INDEX,
  CLEAR_HEADER_FILTERS,
  UPDATE_SORT_TYPE,
  UPDATE_CUSTOM_COL_ORDER,
  CLEAR_CUSTOM_COL_ORDER,
  UPDATE_FROM,
  UPDATE_HEADER_FILTER,
  REMOVE_HEADER_FILTER,
  UPDATE_SORT_BY,
  UPDATE_INPUT_VALUE,
  UPDATE_ROW_SIZE,
  UPDATE_MAX_ROW_SIZE,
  ON_ROW_SIZE_CHANGE,
  FROM_SIZE,
  defaultSearchFilters,
  listOrder,
  CLEAR_SELECTED_PROJECTS,
  DELETE_FILTER,
  TOGGLE_POPUP,
  UPDATE_POPUP_PAGE,
  POST_PROJECT_CHANGES_START,
  POST_PROJECT_CHANGES_SUCCESS,
  POST_PROJECT_CHANGES_ERROR,
  FINISH_LOADING,
  UPDATE_ERRORS,
  SELECT_CUSTOM_VIEW,
  UPDATE_ALL_HEADER_FILTERS,
  RESET_HEADER_FILTERS,
  SHOW_CHANGED_PROJECTS,
  TOGGLE_NOTIFY,
  FILTER_CHANGE
} from './constants'
import {
  createReducer
} from 'helpers/ReducerUtil'
import _, { create } from 'lodash'

import * as R from 'ramda'

const updateMaxRowSize = (prev, { size }) => P.isNotNil(size)
  ? size
  : prev

const updateSortBy = (prev, { value }) => P.isNotNil(value)
  ? value
  : prev


const updateHeaderFilter = (prev, { filterType, filter }) =>
  R.and(P.isNotNil(filterType), P.isNotEmptyOrNil(filter))
    ? R.compose(
      R.assoc(filterType, R.__, prev),
      R.compose(
        R.uniq,
        R.append(R.__, R.prop(filterType, prev)),
      )
    )(filter)
    : prev

const removeHeaderFilter = (prev, { filter }) => {
  let removal = Object.keys(filter)[0]
  let filters = R.pickBy((val, key) => removal !== key, prev)
  return filters
}


const updateFrom = (prev, { from }) => P.isNotNil(from)
  ? from
  : prev


const updateSortType = (prev, { value }) => P.isNotNil(value)
  ? value
  : prev

const updateSortIndex = (prev, { index }) => P.isNotNil(index)
  ? index
  : prev

const updateListOrder = (prev, { listOrder }) => P.isNotNil(listOrder)
  ? listOrder
  : prev

const updateCustomColOrder = (prev, { colOrder }) => P.isNotNil(colOrder)
  ? colOrder
  : prev

const updateProjectList = (prev, { list }) => {
  return P.isNotNil ? list : prev
}

const updateSelectedProjects = (prev, { id }) => {
  let current = [...prev]
  // let current = _.cloneDeep ( prev )
  if (current.indexOf(id) !== -1) {
    let index = current.indexOf(id)
    current.splice(index, 1)
  } else {
    current.push(id)
  }
  return current
}

const clearSelectedProjects = () => []
const updateCurrentFormChanges = (prev, { formDetails, formType }) => {
  return {
    formDetails,
    formType
  }
}

const updateChangedProjects = (prev, { projects }) => {
  let current = projects
  let ids = projects.map((project) => {
    return project.id
  })

  prev.forEach((project) => {
    if (!ids.includes(project.id)) {
      current.push(project)
    }
  })
  return current

}

const deleteChangedProjects = (prev, action) => []

const updateCurrentIndex = (prev, { columnIndex }) => columnIndex !== undefined
  ? columnIndex
  : null
const updateInputHeaderList = (prev, { filters }) => P.isNotNil(filters)
  ? filters
  : prev
const updateMenuActive = (prev, { active }) => P.isNotNil(active)
  ? active
  : prev

const updateInputValue = (prev, { value }) => P.isNotNil(value)
  ? value
  : prev

const updateRowSize = (prev, { size }) => {
  if (size !== 'View all') {
    size = parseInt(size)
  }
  return (P.isNotNil(size) ? size : prev)
}

const togglePopup = (prev) => !prev

const togglePopupPage = (prev, { page }) => page

const toggleRender = (value) => !value

const updateErrors = (prev, { errors }) => {
  return errors
}

const changeView = (prev, { view }) => {
  return view
}

const updateAllHeaderFilters = (prev, { filters }) => filters

const resetHeaderFilters = (prev) => {
  return {}
}

const updateList = (prev, { list }) => list

const toggleNotify = (prev, { toggle }) => toggle

const updateSearchFilter = (prev, { value }) => {
  let current = [...prev]
  // let current = _.cloneDeep ( prev )
  if (current.indexOf(value) !== -1) {
    let index = current.indexOf(value)
    current.splice(index, 1)
  } else {
    current.push(value)
  }
  return current
}

const projectsReducer = createReducer([], {
  [UPDATE_MY_PROJECTS_LIST]: updateProjectList
})

const selectedProjectsReducer = createReducer([], {
  [UPDATE_SELECTED_PROJECTS]: updateSelectedProjects,
  [CLEAR_SELECTED_PROJECTS]: clearSelectedProjects
})

const changedProjectsReducer = createReducer([], {
  [UPDATE_CHANGED_PROJECTS]: updateChangedProjects,
  [CANCEL_CHANGES]: deleteChangedProjects
})

const currentFormChangeReducer = createReducer({}, {
  [APPLY_CHANGES]: updateCurrentFormChanges
})

const menuActiveReducer = createReducer(false, {
  [UPDATE_MENU_ACTIVE]: updateMenuActive
})

const inputHeaderSourceReducer = createReducer([], {
  [UPDATE_INPUT_HEADER_LIST]: updateInputHeaderList
})
const headerFiltersReducer = createReducer({}, {
  [UPDATE_HEADER_FILTER]: updateHeaderFilter,
  [REMOVE_HEADER_FILTER]: removeHeaderFilter,
  [UPDATE_ALL_HEADER_FILTERS]: updateAllHeaderFilters,
  [RESET_HEADER_FILTERS]: resetHeaderFilters
})

const searchFiltersReducer = createReducer(defaultSearchFilters, {
  [FILTER_CHANGE]: updateSearchFilter
})

const listOrderReducer = createReducer(listOrder, {
  [CLEAR_CUSTOM_COL_ORDER]: R.always(listOrder),
  [UPDATE_LIST_ORDER]: updateListOrder
})

const columnIndexReducer = createReducer(null, {
  [UPDATE_CURRENT_INDEX]: updateCurrentIndex
})

const sortIndexReducer = createReducer(0, {
  [CLEAR_HEADER_FILTERS]: R.always(0),
  [UPDATE_SORT_INDEX]: updateSortIndex
})

const sortTypeReducer = createReducer('id', {
  [CLEAR_HEADER_FILTERS]: R.always('id'),
  [UPDATE_SORT_TYPE]: updateSortType
})

const customColOrderReducer = createReducer(false, {
  [CLEAR_CUSTOM_COL_ORDER]: () => false,
  [UPDATE_CUSTOM_COL_ORDER]: updateCustomColOrder
})

const fromReducer = createReducer(0, {
  [UPDATE_FROM]: updateFrom
})
const sortByReducer = createReducer('desc', {
  [CLEAR_HEADER_FILTERS]: R.always('desc'),
  [UPDATE_SORT_BY]: updateSortBy
})

const inputValueReducer = createReducer('', {
  [UPDATE_INPUT_VALUE]: updateInputValue,
})

const rowSizeReducer = createReducer(FROM_SIZE, {
  [UPDATE_ROW_SIZE]: updateRowSize
})
const maxRowSizeReducer = createReducer(0, {
  [UPDATE_MAX_ROW_SIZE]: updateMaxRowSize
})

const popupReducer = createReducer(false, {
  [TOGGLE_POPUP]: togglePopup
})
const popupPageReducer = createReducer('', {
  [UPDATE_POPUP_PAGE]: togglePopupPage
})

const loadingRenderReducer = createReducer(false, {
  [POST_PROJECT_CHANGES_START]: toggleRender,
  [POST_PROJECT_CHANGES_SUCCESS]: toggleRender,
  [POST_PROJECT_CHANGES_ERROR]: toggleRender
})

const errorsReducer = createReducer([], {
  [UPDATE_ERRORS]: updateErrors
})

const selectedViewReducer = createReducer('', {
  [SELECT_CUSTOM_VIEW]: changeView
})

const postUpdatedReducer = createReducer([], {
  [SHOW_CHANGED_PROJECTS]: updateList
})

const toggleNotifyReducer = createReducer(false, {
  [TOGGLE_NOTIFY]: toggleNotify
})

const myProjectsReducer = combineReducers({
  projects: projectsReducer,
  selectedProjects: selectedProjectsReducer,
  changedProjects: changedProjectsReducer,
  currentFormChanges: currentFormChangeReducer,
  searchFilters: searchFiltersReducer,
  listOrder: listOrderReducer,
  headerFilters: headerFiltersReducer,
  columnIndex: columnIndexReducer,
  inputHeaderSource: inputHeaderSourceReducer,
  menuActive: menuActiveReducer,
  sortIndex: sortIndexReducer,
  sortType: sortTypeReducer,
  customColOrder: customColOrderReducer,
  from: fromReducer,
  sortBy: sortByReducer,
  inputValue: inputValueReducer,
  rowSize: rowSizeReducer,
  maxRowSize: maxRowSizeReducer,
  popup: popupReducer,
  popupPage: popupPageReducer,
  loadingRender: loadingRenderReducer,
  errors: errorsReducer,
  selectedView: selectedViewReducer,
  postUpdated: postUpdatedReducer,
  toggleNotify: toggleNotifyReducer
})

export {
  myProjectsReducer
}